import { handleActions } from 'redux-actions';
import { RESET_REGISTER_FLOW_STATE, SET_MANUAL_FACEBOOK_EMAIL } from './actions';


const initialState = {
  manualFacebookEmail: '',
};

export const setManualFacebookEmail = (state, { payload }) => {
  const { email } = payload;

  return { ...state, manualFacebookEmail: email };
};


export const resetRegisterFlowState = () => ({ ...initialState });


const mappedReducers = {
  [SET_MANUAL_FACEBOOK_EMAIL]: setManualFacebookEmail,
  [RESET_REGISTER_FLOW_STATE]: resetRegisterFlowState,
};

const registerFlowState = handleActions(mappedReducers, initialState);

export default registerFlowState;
